import React from "react";
import styled from "styled-components";
import { greyText, lightGreenBackground, darkGreen } from "../../../styles";
import { CompassParagraph } from "../styledComponents";
import { Icon, IconContainer } from "../../visuals/styledComponents";

const BannerContainer = styled.div<{ bgColor?: string }>`
  display: flex;
  padding: 16px;
  background: ${({ bgColor }): string => bgColor ?? lightGreenBackground};
  border-radius: 10px;
  gap: 12px;
  width: 100%;
  align-items: flex-start;
`;

const BannerContent = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;
  flex: 1;
`;

const BannerTitle = styled(CompassParagraph)<{ titleColor?: string }>`
  font-size: 15px;
  color: ${({ titleColor }): string => titleColor ?? darkGreen};
  margin: 0;
  margin-bottom: 4px;
`;

const BannerText = styled(CompassParagraph)`
  font-size: 13px;
  color: ${greyText};
  margin: 0;
  line-height: 1.4;
`;

export interface ModalInfoBannerProps {
  /** Banner title */
  title?: string;
  /** Banner description text */
  description?: string;
  /** Icon source */
  icon?: string;
  /** Background color (default: lightGreenBackground) */
  bgColor?: string;
  /** Title text color (default: darkGreen) */
  titleColor?: string;
  /** Icon background color */
  iconBgColor?: string;
  /** Custom content instead of title/description */
  children?: React.ReactNode;
}

/**
 * A colored info banner with icon, title, and description
 * Used for highlighting important information or instructions
 */
export const ModalInfoBanner: React.FC<ModalInfoBannerProps> = ({
  title,
  description,
  icon,
  bgColor,
  titleColor,
  iconBgColor = "white",
  children,
}) => {
  return (
    <BannerContainer bgColor={bgColor}>
      {icon && (
        <IconContainer size={40} bg={iconBgColor} br={20}>
          <Icon src={icon} height={50} />
        </IconContainer>
      )}
      <BannerContent>
        {children || (
          <>
            {title && (
              <BannerTitle titleColor={titleColor}>{title}</BannerTitle>
            )}
            {description && <BannerText>{description}</BannerText>}
          </>
        )}
      </BannerContent>
    </BannerContainer>
  );
};
